import { dataFont } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFont = /*#__PURE__*/createIcon(dataFont)
export default IconFont
